import { render, staticRenderFns } from "./tuiReport.vue?vue&type=template&id=046d56a4&scoped=true&"
import script from "./tuiReport.vue?vue&type=script&lang=js&"
export * from "./tuiReport.vue?vue&type=script&lang=js&"
import style0 from "./tuiReport.vue?vue&type=style&index=0&id=046d56a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d56a4",
  null
  
)

export default component.exports